import useSWR from 'swr'
import { User_SchoolClasses } from '@graphql/queries'
import { preventPublicRequest } from '@helpers/api'

const useUserSchoolClasses = () => {
  const { data, error, mutate, isValidating } = useSWR(
    preventPublicRequest(User_SchoolClasses)
  )
  const schoolClasses = data?.currentUser?.schoolClasses ?? []
  const sortedSchoolClasses = schoolClasses.sort(
    (a, b) => (a.name > b.name && 1) || -1
  )

  return {
    schoolClasses: sortedSchoolClasses,
    error,
    mutate,
    isValidating,
    isLoading: !error && !data,
  }
}

export { useUserSchoolClasses }
